import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BrandVoiceAbout',
    props: {
        tax: {
            required: true,
            type: Object,
        },
        text: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * BaseImage bind attrs
         */
        const baseImage = computed(() => {
            const { field_file: svg, field_logo: image, name } = props.tax?.fields || {};
            const attrs = {
                alt: name,
                isBlurhashEnabled: false,
            };
            if (svg?.value) {
                return {
                    ...attrs,
                    image: svg.value,
                    shouldCrop: false,
                    shouldUseWebp: false,
                };
            }
            if (image?.value) {
                return {
                    ...attrs,
                    image: image.value,
                };
            }
            return false;
        });
        const title = props.tax?.fields?.field_media_title?.value || '';
        return {
            baseImage,
            css,
            title,
        };
    },
});
